<template>
  <div class="rexer_events__filters">
    <ul class="rexer_events__filters-wrap">
      <li class="rexer_events__filter filter_all">
        <a
          :title="title"
          :class="{ 'active': 'all' === filterItem}"
          href="#"
          @click.prevent="filterHandle('all')"
        >
          {{ title }}
        </a>
      </li>
      <li
        v-for="(item, index) in filters"
        :key="index"
        :id="'filter-' + item.id"
        :class="item.custom_class"
        class="rexer_events__filter"
      >
        <a
          :class="{ 'active': 'item.slug' === filterItem}"
          :title="item.name"
          href="#"
          @click.prevent="filterHandle(item)"
        >
          {{ item.name }}
        </a>
      </li>
      <li
        class="rexer_events__filter"
      >
        <location-dropdown
          :locations="locationSorted"
          :selection="locationsSelection"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import LocationDropdown from './LocationDropdown'
import { uniqBy } from 'lodash'
export default {
  name: 'FilterEvents',
  components: {
    LocationDropdown
  },
  props: {
    filters: {
      type: Array,
      default: function () {
        return []
      }
    },
    title: {
      type: String,
      default: 'All'
    },
    selection: {
      type: String,
      default: ''
    },
    locations: {
      type: Array,
      default: () => []
    },
    locationsSelection: {
      type: String,
      default: 'Choose'
    }
  },
  data () {
    return {
      filterItem: 'all'
    }
  },
  computed: {
    locationSorted () {
      return uniqBy(this.locations, 'value')
    }
  },
  watch: {
    selection (val) {
      if (val) {
        this.selectedFilter(val)
      }
    }
  },
  mounted () {
    if (this.selection !== '' && this.filters) {
      this.selectedFilter(this.selection)
    }
  },
  methods: {
    filterHandle (val) {
      let item = ''
      if (val === 'all') {
        this.filterItem = 'all'
        item = 'all'
      } else {
        this.filterItem = val.slug
        item = val.id
      }
      this.$geb.emit({ id: 'eventFilter', payload: Object.assign({}, { item: item }) })
    },
    selectedFilter (val) {
      const result = this.filters.filter(item => item.id.toString() === val)
      this.filterItem = result.slug
    }
  }
}
</script>

<style lang="scss" scoped>
$black: #000;
$purple: #b004ff;
$blue: #0248ff;
$green: #00ff00;
$color-active: #fff;
 @mixin filter_state ($color-state, $text-color-active) {
   a {
    border-color: $color-state;
    color: $color-state;
    &:hover, &:active, &:focus, &.active{
      background: $color-state;
      color: $text-color-active;
    }
   }
 }
.rexer_events{
  &__filters{
    display: flex;
    margin: 2rem 0;
    &-wrap{
      list-style: none;
      padding: 0;
      margin:0;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }
  }
  &__filter {
    margin: 0.5rem 0;
    width: 100%;
    a {
      background: transparent;
      padding: 0.25rem 2rem;
      display: block;
      text-align: center;
      font-weight: bold;
      font-size: 1rem;
      border: 4px solid $black;
      transition: all 330ms ease;
    }
    &.filter_all{
      @include filter_state($black, $color-active);
    }
    &.is-green{
      @include filter_state($green, $color-active);
    }
    &.is-purple{
      @include filter_state($purple, $color-active);
    }
    &.is-blue{
      @include filter_state($blue, $color-active);
    }
  }
}

@media screen and (min-width: 768px) {
  .rexer_events{
    &__filters{
      justify-content: center;
    }
    &__filter {
      width: auto;
      margin: 0.5rem;
    }
  }
}

@media screen and (min-width: 992px) {
  .rexer_events{
    &__filter {
      a {
        padding: 0.5rem 2rem;
        min-width: 130px;
      }
    }
  }
}

@media screen and (min-width: 1440px) {
  .rexer_events{
    &__filter {
      a {
        min-width: 140px;
      }
    }
  }
}

</style>
